import { useState } from "react";
import {
  IconButton,
  Tabs,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { toast } from "react-toastify";
import {
  useForgetPasswordMutation,
} from "../store/auth/authApiSlice";
import { Box } from "@mui/material";
import CustomButton from "../theme/style-components/CustomButton";
import CustomInput from "../theme/style-components/CustomInput";
import * as yup from "yup";
import { useFormik } from "formik";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { showError } from "../shared/helperFunction";
import loginBg from "../assets/images/Black_logo.jpg"
import Logo from "../assets/images/logo.png"

import Tab from '@mui/material/Tab';
import blackLogo from "../assets/images/black_logo.svg"
import lightLogo from "../assets/images/white-logo.svg"
import SignIn from "../components/SignIn";
import SignUp from "../components/SignUp";


const Auth = () => {
  const theme = useTheme()
  const [forgetPassword, { isLoading: isForgotLoading }] = useForgetPasswordMutation();
  const [isForget, setIsForget] = useState(false);
  const [value, setValue] = useState(0);

  const forgotValidationSchema = yup.object({
    forgotEmail: yup
      .string()
      .email("Plase enter a valid email"),
  });

  const themeLogo = theme.palette.mode === 'dark' ? lightLogo : blackLogo

  const forgotFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotValidationSchema,
    onSubmit: async (values) => {
      const { email } = values;
      try {
        const userData = await forgetPassword({ email: email }).unwrap();
        toast.success("Email sent successfully!");
        setIsForget(!isForget);
      } catch (err) {
        showError(err?.data);
      }
    }
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleForget = () => {
    setIsForget(!isForget);
  }

  const headingDetails = value === 0 ? "Enter your email and password to access your account." : "Please enter your contact details to connect";
  return (
    <Box sx={{ height: "100vh" }}>
      <Grid container spacing={0} sx={{ height: "100%" }}>
        <Grid items xs={12} md={6} sx={{ display: { xs: "none", md: "block" } }}>
          <Box sx={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center", background: theme.palette.background.default }}>
            <img src={loginBg} alt="loginBg" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </Box>
        </Grid>
        <Grid items xs={12} md={6} sx={{ height: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", background: theme.palette.background.paper, padding: { sm: "30px", md: "30px", xs: "30px" }, position: "relative" }}>
            <Box sx={{ maxWidth: "500px", width: "100%" }}>
              <Box sx={{ display: "flex", alignItems: "center", marginBottom: "30px", justifyContent: "center", flexDirection: "column", textAlign: "center", }}>
                <img style={{
                  objectFit: 'contain'
                }} width={150} height={50} src={Logo} alt="logo" />
                {!isForget ? <Typography sx={{ color: "#9797A9", fontSize: "14px", lineHeight: "20px", fontWeight: "400", marginTop: "10px" }}>{headingDetails}</Typography> : null}
              </Box>
              {
                isForget ?
                <form>
                    <Box sx={{
                      textAlign: "start",
                      position: "absolute",
                      top: "30px",
                      left: "30px", "& svg": {
                        color: "#000",
                      }
                    }}>
                      <IconButton sx={{
                        backgroundColor: 'rgba(0,0,0,0.08)',
                      }}
                      onClick={() => {
                        setIsForget(false);
                      }}
                    >
                      <KeyboardBackspaceIcon
                        sx={{
                          fill:
                            theme?.palette?.mode === "light"
                              ? theme.palette.grey[800]
                              : theme.palette.grey[500],
                        }}
                      />
                    </IconButton>
                  </Box>
                    <Typography variant="h2" sx={{
                      fontSize: "22px !important",
                      lineHeight: "30px !important",
                      fontWeight: "700 !important",
                      color: `#5bbba9 !important`,
                      textAlign: "center",
                      marginBottom: "20px"
                    }}>
                    Forget Password?
                  </Typography>
                  <CustomInput
                    id="email"
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Email"
                    name="email"
                    value={forgotFormik.values.email}
                    onChange={forgotFormik.handleChange}
                    error={
                      forgotFormik.touched.email &&
                      Boolean(forgotFormik.errors.email)
                    }
                    helperText={
                      forgotFormik.touched.email && forgotFormik.errors.email
                    }
                  />
                  <Box sx={{ marginTop: "20px" }}>
                    <CustomButton
                      type="submit"
                      fullWidth
                      disabled={isForgotLoading}
                      size="large"
                      color="primary"
                      onClick={forgotFormik.handleSubmit}
                      buttonName={isForgotLoading ? "Submiting..." : "Submit"}
                    />
                  </Box>
                </form>
                  : <>
                    {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", }}>
                      <Typography variant='h4' sx={{ color: "#5bbba9", marginBottom: "10px" }}>
                      Sign
                    </Typography>
                  </Box> */}
                  <Tabs
                    value={value}
                    sx={{
                      marginBottom: "25px",
                      '& .Mui-selected': {
                        color: `${theme.palette.common.white} !important`,
                        backgroundColor: `${theme.palette.primary.main} !important`,
                        border: "none",
                      },
                      '& .MuiTabs-indicator': {
                        display: "none",
                      }
                    }}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                  >
                    <Tab value={0} sx={{ backgroundColor: theme.palette.primary.light, borderRadius: "6px", width: "50%", color: theme.palette.text.primary, fontSize: "16px", lineHeight: "20px", textTransform: "none", fontWeight: "400" }} label="Sign In" {...a11yProps(0)} /> 
                     <Tab value={1} sx={{ backgroundColor: theme.palette.primary.light, borderRadius: "0 6px 6px 0", width: "50%", color: theme.palette.text.primary, fontSize: "16px", lineHeight: "20px", textTransform: "none", fontWeight: "500" }} label="Sign Up" {...a11yProps(0)} />
                  </Tabs>
                  <CustomTabPanel value={value} index={0}>
                    <SignIn handleForget={handleForget} />
                  </CustomTabPanel>
                  <CustomTabPanel value={value} index={1}>
                    <SignUp />
                  </CustomTabPanel>
                  </>}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Auth;
